import React, { useState, useEffect } from "react";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import "./accordion.css";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import Quill from "quill";

const Parchment = Quill.import("parchment");
const ListColor = new Parchment.Attributor.Style("list-color", "color", {
  scope: Parchment.Scope.BLOCK,
});
Quill.register(ListColor, true);

function Accordion({ id, title, content, isOpen, onToggle }) {
  const { quill, quillRef } = useQuill({
    readOnly: true,
    modules: { toolbar: false },
  });

  useEffect(() => {
    if (quill) {
      quill.setContents(content);
    }
  }, [content, quill]);

  useEffect(() => {
    if (quill && content) {
      quill.setContents([]);

      quill.setContents(content);

      setTimeout(() => {
        const lines = quill.getLines(0, quill.getLength());

        lines.forEach((line) => {
          if (line.domNode.tagName === "LI") {
            const savedColor = line.formats()["list-color"];

            if (savedColor) {
              line.domNode.style.color = savedColor;
            } else {
              const coloredChild =
                line.domNode.querySelector('[style*="color"]');
              if (coloredChild && coloredChild.style.color) {
                line.domNode.style.color = coloredChild.style.color;
              }
            }
          }
        });
      }, 50);
    }
  }, [quill, content]);

  const toggleAcordeon = () => {
    onToggle(isOpen ? null : id);
  };

  return (
    <>
      <div className="container">
        <div className="acordeonContainer">
          <div className="acrodeonItem" onClick={toggleAcordeon}>
            <h5>{title}</h5>
            <i>{isOpen ? <AiOutlineUp /> : <AiOutlineDown />}</i>
          </div>
          <div className={`acordeonInfo ${isOpen ? "open" : "closed"}`}>
            <div className="editor">
              <div ref={quillRef}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Accordion;
